/** The app's word for a company for every screen (src/lib/terms.ts), set once signed in. */
import { createContext, useContext, type ReactNode } from 'react';

import { wordsOf, type Words } from './terms.ts';

const Ctx = createContext<Words>(wordsOf(null));

export function WordsProvider({ words, children }: { words: Words; children: ReactNode }) {
  return <Ctx.Provider value={words}>{children}</Ctx.Provider>;
}

export function useWords(): Words {
  return useContext(Ctx);
}
